const $ = require('jquery');

function animateScroll(el: HTMLDivElement, duration: number = 1000, animateWidth?: boolean): void {
    if (el) {
        if (!animateWidth) {
            $(el).animate({ scrollTop: el.scrollHeight }, duration);
        } else {
            $(el).animate({ scrollLeft: el.scrollWidth }, duration);
        }
    }
}

export default animateScroll;
